import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { INQUIRY_PROCESS_NAME, resolveLatestProcessName } from '../../transactions/transaction';

import { Heading, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ListingPage.module.css';

const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
    authorRating,
  } = props;

  if (!listing.author) {
    return null;
  }

  const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);
  const isInquiryProcess = processName === INQUIRY_PROCESS_NAME;
  const isAuthorCurrentUser =
    listing?.author?.id?.uuid &&
    currentUser?.id?.uuid &&
    listing.author.id.uuid === currentUser.id.uuid;
  const verifiedMail = isAuthorCurrentUser
    ? currentUser?.attributes?.emailVerified
    : listing?.author?.attributes?.emailVerified;

  return (
    <section id="author" className={css.sectionAuthor}>
      {/* <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.aboutProviderTitleNew" />
      </Heading> */}
      <UserCard
        user={listing.author}
        currentUser={currentUser}
        onContactUser={onContactUser}
        showContact={!isInquiryProcess}
        authorRatingCont={authorRating}
        storeName={
          listing?.author?.attributes?.profile?.publicData?.rawProfileUrl ||
          listing?.author?.attributes?.profile?.publicData?.profileUrl
        }
        verifiedMail={verifiedMail}
      />
      {isInquiryModalOpen ? (
        <div className={css.inquiryPageOverlay}>
          <TopbarContainer />
          <div className={css.inquiryPageContent}>
            <InquiryForm
              className={css.inquiryForm}
              submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
              listingTitle={title}
              listing={listing}
              authorDisplayName={authorDisplayName}
              sendInquiryError={sendInquiryError}
              onSubmit={onSubmitInquiry}
              inProgress={sendInquiryInProgress}
              onCloseInquiryModal={onCloseInquiryModal}
              currentUser={currentUser}
              verifiedMail={verifiedMail}
            />
          </div>
          <FooterContainer />
        </div>
      ) : null}
    </section>
  );
};

export default SectionAuthorMaybe;
